import { all, takeLatest } from 'redux-saga/effects';
import {
  GET_EMPLOYEES,
  GET_EMPLOYEES_FOR_GROUP,
  GET_EMPLOYEE_CONSUMPTIONS,
  GET_EMPLOYEE_CREDIT_TRANSACTIONS,
  GET_EMPLOYEE_DETAILS,
  GET_EMPLOYEE_SECTION,
  GET_EMPLOYEE_STATUS,
  GET_UPLOAD_STATUS,
  REMOVE_EMPLOYEE_FROM_COMPANY,
  UPLOAD_EMPLOYEES,
  UPSERT_EMPLOYEE,
} from '../../actions/employee';
import {
  getAllEmployeesSaga,
  getEmployeeConsumptionsSaga,
  getEmployeeCreditTransactionsSaga,
  getEmployeeDetailsSaga,
  getEmployeeSectionSaga,
  getEmployeeStatusSaga,
  getEmployeesForGroupSaga,
  getUploadStatusSaga,
  removeEmployeeFromCompanySaga,
  uploadEmployeesSaga,
  upsertEmployeeSaga,
} from './getEmployeesSaga';

function* employeeSagas() {
  yield all([
    yield takeLatest(UPSERT_EMPLOYEE.INITIATE, upsertEmployeeSaga),
    yield takeLatest(GET_EMPLOYEE_SECTION.INITIATE, getEmployeeSectionSaga),
    yield takeLatest(GET_EMPLOYEES.INITIATE, getAllEmployeesSaga),
    yield takeLatest(
      GET_EMPLOYEES_FOR_GROUP.INITIATE,
      getEmployeesForGroupSaga,
    ),
    yield takeLatest(
      REMOVE_EMPLOYEE_FROM_COMPANY.INITIATE,
      removeEmployeeFromCompanySaga,
    ),
    yield takeLatest(GET_EMPLOYEE_DETAILS.INITIATE, getEmployeeDetailsSaga),
    yield takeLatest(GET_EMPLOYEE_STATUS.INITIATE, getEmployeeStatusSaga),
    yield takeLatest(UPLOAD_EMPLOYEES.INITIATE, uploadEmployeesSaga),
    yield takeLatest(GET_UPLOAD_STATUS.INITIATE, getUploadStatusSaga),
    yield takeLatest(
      GET_EMPLOYEE_CREDIT_TRANSACTIONS.INITIATE,
      getEmployeeCreditTransactionsSaga,
    ),
    yield takeLatest(
      GET_EMPLOYEE_CONSUMPTIONS.INITIATE,
      getEmployeeConsumptionsSaga,
    ),
  ]);
}

export default employeeSagas;
